import { useNavigate } from "react-router-dom";
import { FolderListContainer } from "../../style/contents/backup/backup";
import { BackupFolder } from "../../view/contents/backup/backup.folder.list";
import { BackupUser } from "../../view/contents/backup/backup.user";
import { useEffect } from "react";

interface Props {
  data: BackupFolder[];
  userData: BackupUser[]; // 추후 데이터 변경
  selectedFolders: string[];
  onChange: (rootDirectoryPath: string, checked: boolean) => void;
  deviceId?: string;
  id?: string;
  userAccount?: string;
  role: string;
  userName?: string;
  department?: string;
  pcName?: string;
  onRequestWorm?: (rootDirectoryPath: string) => void;
}

const FolderList = ({
  data,
  userData,
  selectedFolders,
  onChange,
  deviceId,
  id,
  userAccount,
  role,
  userName,
  department,
  pcName,
  onRequestWorm,
}: Props) => {
  const navigate = useNavigate();

  const viewBackupBtn = (rootDirectoryPath: string, createDate: string) => {
    const encodedDeviceId = encodeURIComponent(deviceId || "");
    const encodedRootDirectoryPath = encodeURIComponent(rootDirectoryPath);
    const encodedCreateDate = encodeURIComponent(createDate);
    const encodedUserAccount = encodeURIComponent(userAccount || "");

    localStorage.setItem(
      "directory",
      JSON.stringify({
        directoryPath: rootDirectoryPath,
        createDate: createDate,
      }),
    );

    navigate(
      `/backup/date/select/${encodedDeviceId}?deviceId=${encodedDeviceId}&id=${id}&userAccount=${encodedUserAccount}&rootDirectoryPath=${encodedRootDirectoryPath}&createDate=${encodedCreateDate}&pcName=${btoa(
        encodeURIComponent(pcName || ""),
      )}`,
    );
  };

  useEffect(() => {
    localStorage.removeItem("initialPath");
  }, []);

  return (
    <FolderListContainer>
      {data.map((item, index) => {
        const isChecked = selectedFolders.includes(item.rootDirectoryPath);

        return (
          <div key={index} className="folder-items">
            <div className="folder-item">
              <div className="input-box">
                {role === "admin" && (
                  <input
                    type="checkbox"
                    id={item.rootDirectoryPath}
                    checked={isChecked}
                    onChange={(e) =>
                      onChange(item.rootDirectoryPath, e.target.checked)
                    }
                  />
                )}
                <label htmlFor={item.rootDirectoryPath}>{item.name}</label>
              </div>
              <div className="view-backup">
                {role === "admin" && (
                  <button
                    type="button"
                    className="worm"
                    onClick={() => onRequestWorm?.(item.rootDirectoryPath)}
                  >
                    WORM
                  </button>
                )}
                <button
                  type="button"
                  onClick={() =>
                    viewBackupBtn(item.rootDirectoryPath, item.createDate)
                  }
                >
                  백업 목록 보기
                </button>
              </div>
            </div>

            <div className="info">
              <div className="folder-info">
                <p>마지막 백업 시간 : {item.createDate}</p>
              </div>
              <div className="user-info">
                <span>아이디: {userData[0].userAccount}</span>
                <span>부서: {department}</span>
                <span>이름: {userName}</span>
              </div>
            </div>
          </div>
        );
      })}
    </FolderListContainer>
  );
};

export default FolderList;
